const DIALOG_SELECTOR = '[data-dialog]';
const CLOSE_SELECTOR = '[data-dialog-close]';


export default function () {
    document.addEventListener('click', event => {
        const element = event.target.closest(DIALOG_SELECTOR);

        if (!element) {
            return;
        }

        const dialog = document.querySelector(element.dataset.dialog);

        if (!dialog) {
            return;
        }

        dialog.showModal();
    });

    document.addEventListener('click', event => {
        const button = event.target.closest(CLOSE_SELECTOR);

        if (!button) {
            return;
        }

        const dialog = button.closest('dialog');

        if (!dialog) {
            return;
        }

        dialog.close();
    });
}
